import {messages} from '@smartmixin/i18n';
import {Star} from '@phosphor-icons/react';
import {alpha, ButtonBase, Grid, Typography, useTheme} from '@mui/material';
import {useIntl} from 'react-intl';
import {useNavigate} from 'react-router';
import AppPaper from '../../components/AppPaper';
import {
  CATEGORY_MESSAGES,
  getReadingTime,
  POPULAR_ARTICLE_SLUGS,
} from '../constants';
import {useArticles} from '../hooks/useArticles';
import {useHelpBasePath} from '../hooks/useHelpLocale';

// Curated top-support-driver tiles shown above the category grid
const PopularArticles = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const {formatMessage} = useIntl();
  const {getArticleBySlug} = useArticles();
  const helpBasePath = useHelpBasePath();

  const articles = POPULAR_ARTICLE_SLUGS.map((slug) =>
    getArticleBySlug(slug),
  ).filter((article) => article !== undefined);

  if (articles.length === 0) {
    return null;
  }

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: 'text.primary',
          mb: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}>
        <Star size={22} weight="fill" color={theme.palette.warning.main} />
        {formatMessage(messages.common.popularArticles)}
      </Typography>
      <Grid container spacing={2} sx={{mb: 5}}>
        {articles.map((article) => (
          <Grid key={article.id} size={{xs: 12, sm: 6}}>
            <ButtonBase
              onClick={() => navigate(`${helpBasePath}/${article.slug}`)}
              sx={{width: '100%', textAlign: 'left', borderRadius: 2}}>
              <AppPaper
                sx={{
                  p: 2.5,
                  width: '100%',
                  height: '100%',
                  transition: 'all 200ms ease',
                  '&:hover': {
                    borderColor: theme.palette.primary.main,
                    backgroundColor: alpha(theme.palette.primary.main, 0.02),
                  },
                }}>
                <Typography
                  variant="subtitle1"
                  sx={{fontWeight: 600, color: 'text.primary', mb: 0.5}}>
                  {article.title}
                </Typography>
                <Typography variant="body2" sx={{color: 'text.secondary'}}>
                  {CATEGORY_MESSAGES[article.category]
                    ? formatMessage(CATEGORY_MESSAGES[article.category])
                    : article.category}
                  {' · '}
                  {formatMessage(messages.common.minRead, {
                    minutes: getReadingTime(article.content),
                  })}
                </Typography>
              </AppPaper>
            </ButtonBase>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default PopularArticles;
